<div class="error-message" *ngIf="razonSocialError && nombreComercialError">Por favor, escriba una razón social y nombre comercial.</div>
<div class="error-message" *ngIf="razonSocialError && !nombreComercialError">Por favor, escriba una razón social.</div>
<div class="error-message" *ngIf="!razonSocialError && nombreComercialError">El campo nombre comercial no puede estar vacío.</div>
<div class="error-message" *ngIf="(!razonSocialError && !nombreComercialError) && (telefonoError || nifError)"> Hay campos introducidos incorrectamente.</div>
<div class="ok-message fade-out" *ngIf="!razonSocialError && !nombreComercialError && !telefonoError && !nifError && clienteCreado && !errorFinal">
    El cliente se ha creado correctamente.
</div>
<div class="error-message fade-out" *ngIf="errorFinal">{{errorMessage}}</div>

<div class="container">
    <div class="header">
        <div class="header-content">
            <span class="font20">NUEVO CLIENTE DATABEER</span>
            <button mat-icon-button matTooltip="Registrar nuevo cliente" class="gurdar-btn" (click)="guardarCliente()" [disabled]="waitAfterSave">
                <mat-icon>save</mat-icon>
            </button>
        </div>
        <span class="header-text font14">Formulario de clientes DataBeer</span>
    </div>

    <div class="body">
        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container">
                <mat-label class="label-text" [ngClass]="{'error-select': razonSocialError}">Razón social</mat-label>
                <input matInput placeholder="Nombre con que la entidad o sociedad mercantil está registrada legalmente" formControlName="razonSocial" required>
                <button *ngIf="razonSocialInput?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearField('razonSocial')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-error *ngIf="razonSocialError" class="custom1">El campo Razon social no puede estar vacío</mat-error>
        </form>

        <!--<div *ngIf="razonSocialError" class="error-container" style="margin-bottom: 20px; margin-top: -10px;">
            <span style="color: rgba(255, 0, 0, 0.993); font-size: 14px;">
                El campo Razon social no puede estar vacío
            </span>
        </div>-->

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text" [ngClass]="{'error-select': nombreComercialError}">Nombre comercial</mat-label>
                <input matInput placeholder="Nombre que identifica a la empresa en el tráfico mercantil" formControlName="nombreComercial" required>
                <button *ngIf="nombreComercialInput?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearField('nombreComercial')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-error *ngIf="nombreComercialError" class="custom1">El campo Nombre comercial no puede estar vacío</mat-error>
        </form>

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text">Iniciales</mat-label>
                <input matInput placeholder="Iniciales de la empresa" formControlName="iniciales">
                <button *ngIf="inicialesInput?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearField('iniciales')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </form>

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text" [ngClass]="{'error-select': nifError}">NIF o NIE</mat-label>
                <input matInput placeholder="12345678H" formControlName="nif">
                <button *ngIf="nifInput?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearField('nif')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-error *ngIf="nifError" class="custom1">El NIF o NIE no es correcto.</mat-error>
        </form>

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text" [ngClass]="{'error-select': telefonoError}">Teléfono</mat-label>
                <!--<mat-form-field matPrefix appearance="fill" style="margin: 0;">
                    +
                    <input matInput type="text" formControlName="prefijo" style="width: 60px;" value="34">
                </mat-form-field>-->
                <input matInput placeholder="600 00 00 00" formControlName="telefono" mask="000 00 00 00">
                <mat-icon matPrefix>phone</mat-icon>
                <button *ngIf="telefonoInput?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearField('telefono')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-error *ngIf="telefonoError" class="custom1">El número de teléfono introducido no es correcto.</mat-error>
        </form>

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text">Persona de contacto</mat-label>
                <input matInput placeholder="Nombre y apellidos de persona de contacto" formControlName="personaContacto">
                <button *ngIf="personaContactoInput?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearField('personaContacto')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </form>

        <div class="input-container2 custom2">
            <span class="label-text marginLeft1P">Estado</span>
            <div class="radio-button-container">
                <mat-radio-group aria-label="Estado del cliente" [(ngModel)]="estado" >
                    <mat-radio-button value="1">Activado</mat-radio-button>
                    <mat-radio-button value="0">Desactivado</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
    </div>
</div>
<div class="footer"></div>
